export const constructImagesUrl = (suffix: string): string => `/images/${suffix}`;
